import axiosClient from "../../http-common";

class SeedTypesApiService{
    addNewSeedType = async (tenantId, containerId, newSeedType) => {
        return await axiosClient.post(`/api/v1/tenants/${tenantId}/containers/${containerId}/seedtypes`, newSeedType);
    };

    deleteSeedType = async (tenantId, containerId, seedTypeId) =>{
        return await axiosClient.delete(`/api/v1/tenants/${tenantId}/containers/${containerId}/seedtypes/${seedTypeId}`);
    };

    getAllSeedTypes = async (tenantId, containerId, includeOutdated, include) => {
        const queryParams = includeOutdated ? `?IncludeOutdated=${includeOutdated}` + (include ? `&include=${include}` : '') : include ? `?include=${include}` : '';
        return await axiosClient.get(`/api/v1/tenants/${tenantId}/containers/${containerId}/seedtypes${queryParams}`)
    };

    getSeedTypea = async (tenantId, containerId, seedTypeId, includeOutdated) => {
        const queryParams = includeOutdated ? `?IncludeOutdated=${includeOutdated}` : '';
        return await axiosClient.get(`/api/v1/tenants/${tenantId}/containers/${containerId}/seedtypes/${seedTypeId}${queryParams}`);
    };

    updateSeedType = async (tenantId, seedTypeId, editedSeedType) => {
        return await axiosClient.put(`/api/v1/tenants/${tenantId}/seedtypes/${seedTypeId}`, editedSeedType);
    };
};

export default new SeedTypesApiService();